const ENABLED_KEY = 'notifications.browserEnabled'

export interface BrowserNotificationPayload {
  title: string
  body: string
  tag?: string
  link?: string | null
}

export const browserNotifications = {
  isSupported(): boolean {
    return typeof window !== 'undefined' && 'Notification' in window
  },
  permission(): NotificationPermission | 'unsupported' {
    if (!this.isSupported()) return 'unsupported'
    return Notification.permission
  },
  isEnabled(): boolean {
    if (!this.isSupported()) return false
    if (Notification.permission !== 'granted') return false
    return localStorage.getItem(ENABLED_KEY) !== '0'
  },
  setEnabled(enabled: boolean): void {
    if (enabled) localStorage.removeItem(ENABLED_KEY)
    else localStorage.setItem(ENABLED_KEY, '0')
  },
  async requestPermission(): Promise<NotificationPermission | 'unsupported'> {
    if (!this.isSupported()) return 'unsupported'
    if (Notification.permission === 'granted' || Notification.permission === 'denied') {
      return Notification.permission
    }
    return Notification.requestPermission()
  },
  show(payload: BrowserNotificationPayload, navigate?: (path: string) => void): void {
    if (!this.isEnabled()) return
    try {
      const n = new Notification(payload.title, {
        body: payload.body,
        tag: payload.tag,
        icon: '/favicon.ico',
      })
      n.onclick = () => {
        window.focus()
        if (payload.link && navigate) navigate(payload.link)
        n.close()
      }
    } catch {
      // ignore
    }
  },
}
